enum TrafficChangesTrend {
    Grew = "grew",
    Declined = "declined",
}

export default TrafficChangesTrend;
